/**
 * Espaces de la typographie française pour les phrases de l'outil : celles de
 * `frenchSpaces`, plus des insécables à l'intérieur des guillemets « … ».
 */

import { frenchSpaces } from '../../ui/format';

const NBSP = String.fromCharCode(0xa0);

export const fr = (s: string) =>
  frenchSpaces(s).replace(/« /g, `«${NBSP}`).replace(/ »/g, `${NBSP}»`);
